import React, { Fragment } from 'react';
import { any, bool, func, node, object, string } from 'prop-types';
import classnames from 'classnames';

import Label from '../Label';
import Icon from '../../icon/Icon';
import Button from '../../button/Button';
import { TranslatedCopy } from '../../../intl/TranslatedCopy';

const types = {
  input: 'ncss-input-container',
  textarea: 'ncss-textarea-container',
  radio: 'ncss-radio-container',
  select: 'ncss-select-container',
  checkbox: 'ncss-checkbox-container'
};

const InputContainer = ({
  label,
  title,
  error,
  required,
  className,
  extraClassName,
  type,
  isSearch,
  children,
  clear,
  dataDesc,
  customStyles
}) => {
  const currType = type || 'input';
  const inputType = types[currType];

  const currChildren = React.Children.toArray(children);
  const childrenWithLabels = currChildren.map(child =>
    React.cloneElement(child, { label: label, className: className, required: required })
  );

  const isCheckbox = label && currType === 'checkbox';
  const errorStyle = isCheckbox
    ? [{ position: 'relative' }, { position: 'relative' }]
    : [{ position: 'absolute' }, { position: 'absolute', bottom: 0 }];

  if (!isCheckbox) {
    const inputLabel = (
      <Label key='label' htmlFor={children.props.name} title={title} className={classnames({ hasIcon: isSearch })}>
        {isSearch && <Icon name='search' alt='search icon' className='mr2-sm' />}
        <span>{label}</span>
      </Label>
    );
    childrenWithLabels.push(inputLabel);
  }

  return (
    <div
      className={classnames('ncss-form-group', extraClassName, { required: required, noLabel: !label })}
      style={customStyles}
    >
      <div
        className={classnames(inputType, {
          error: error
        })}
      >
        {childrenWithLabels}{' '}
        {clear && (
          <>
            {clear && (
              <Button useBareClass textLink aria-label='clear' className='clear' onMouseDown={clear}>
                <Icon name='x' alt='clear' />
              </Button>
            )}
          </>
        )}
        {error && (
          <div
            className='ncss-error-msg bg-white u-full-width z1'
            data-desc={`${dataDesc}_error`}
            style={errorStyle[0]}
            key='error'
          >
            {error}
          </div>
        )}
        {required && !error && (
          <div
            className='inputContainer__required text-color-secondary u-full-width body-4'
            style={errorStyle[1]}
            key='required'
          >
            *
            <TranslatedCopy id='global.required' />
          </div>
        )}
      </div>
    </div>
  );
};

InputContainer.defaultProps = {
  type: 'input',
  title: '',
  className: null,
  extraClassName: '',
  error: null,
  label: '',
  required: false,
  isSearch: false,
  clear: null,
  dataDesc: '',
  customStyles: {}
};

InputContainer.propTypes = {
  type: string,
  className: string,
  extraClassName: string,
  label: any,
  title: string,
  required: bool,
  error: any,
  children: node.isRequired,
  isSearch: bool,
  clear: func,
  dataDesc: string,
  customStyles: object
};

export default InputContainer;
